export const environment = {
    production: false,
    apiURL: 'https://api-qa.myshopyglam.com',
    feURL: 'https://qa.myshopyglam.com',
       fbPixel: {
    enabled: false,
    id: '1519505962663294'
  }
  };
